<template>
  <v-alert type="info" v-if="msg">
    {{msg}}
  </v-alert>
</template>

<script>
export default {
  name: 'fin-info-msg',
  props: {
    msg: {
      type: String
    }
  }
}
</script>

<style scoped>

</style>
